<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>展会设置</BreadcrumbItem>
          <BreadcrumbItem>行业动态</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">行业动态</div>
        <Input
          search
          placeholder="请输入关键字"
          v-model="search"
          @on-search="init"
          style="width:230px;margin-top:20px;"
        />
      </div>
      <div class="header-tool-box">
        <div class="htb-item" :disabled-hover="false" @click="$router.push('/host/index/set/newsadd')">
          <span class="htb-add">+</span>
          <span>添加动态</span>
        </div>
      </div>
    </div>

    <!-- 内容 -->
    <div class="my-item">
      <template v-if="newsList && newsList.length">
        <Row :gutter="30">
          <Col style="width:20%;float:left" v-for="(item, index) in newsList" :key="index">
            <div class="my-item-box">
              <div class="mi-top">
                <img :src="item.coverUrl" v-if="item.coverUrl" />
                <img src="@assets/img/empty.png" v-else />
              </div>
              <div class="mi-title f-tac" :title="item.title">{{item.title}}</div>
              <div class="mi-tool">
                <div class="mi-tool-item z-primary" @click="showEdit(item)">编辑</div>
                <div class="mi-tool-line">|</div>
                <div class="mi-tool-item">
                  <Poptip
                    confirm
                    placement="top-start"
                    title="确认删除此动态吗 ?"
                    @on-ok="delItem(item)"
                    @on-cancel="handleClose()"
                  >删除</Poptip>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <div class="my-page" v-if="totalCount > pageSize">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </template>
      <div class="u-empty" v-else>暂无数据！</div>
    </div>

  </div>
</template>

<script>
import { mapActions } from "vuex";
import emptyList from "@components/emptyList/emptyList";

export default {
  name: "project-set",
  data() {
    return {
      search: "",
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      newsList: []
    };
  },
  components: {
  },
  computed: {
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getHostNews: "hostAuditModule/getHostNews",
      delHostNews: "hostAuditModule/delHostNews"
    }),
    async init() {
      let list = await this.getHostNews(
        {
          "pageSize": this.pageSize,
          "pageIndex": this.pageIndex,
          "Wheres": {
            "type": 0,
            "wheres": {
              "WhereGroupOperator": 0,
              "Predicates": [
                { 
                "type": 1,
                "wheres":{ 
                  "WhereOperator":6,
                    "Label":"title",
                    "Value":"%" + this.search + "%" 
                  } 
                },
              ]
            }
          }
        }
      );
      this.newsList = list.items;
      this.pageSize = list.pageSize;
      this.pageIndex = list.pageIndex;
      this.totalCount = list.totalCount;
      // console.log(111,this.newsList);
    },
    showEdit(e) {
      this.$router.push("/host/index/set/newsedit?id=" + e.id);
    },
    handleClose() {},
    async delItem(e) {
      let bool = await this.delHostNews(e.id)
      if (bool && bool.successed) {
        this.$Message.success("操作成功！");
        this.init();
      } else {
        this.$Message.error("操作失败，请重试！");
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
  }
};
</script>

<style scoped lang="scss">
.my-page {
  text-align: center;
}
</style>

